export const fade = {
  hide: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeIn",
      staggerChildren: 0.085,
      staggerDirection: 1,
    },
  },
  viewport: {
    once: true,
  },
};

export const childFade = {
  hide: { opacity: 0 },
  show: {
    opacity: 1,
  },
  viewport: {
    once: true,
  },
};

export const rise = {
  hide: { opacity: 0, y: 200 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "linear",
    },
  },
  viewport: {
    once: true,
  },
};
